import { TaskTypes } from "@/constants/task-types";
import moment from "moment";

export class DataSourceMonitorData {
  /**
   * Create a Batch Prediction Monitor Data
   * @param {string[]} header - monitor data header
   * @param {any[]} rows - monitor data rows
   * @param {object[]} images_metadata - monitor data images_metadata
   */
  constructor(header = [], rows = [], images_metadata = [], metadata) {
    /** @type {string[]} */
    this.header = header;

    /** @type {any[]} */
    this.rows = rows.map((row) => {
      const d = this.convertUTCDate(row[0]);
      // in case of load more the date is already formatted
      if (!isNaN(d)) {
        row[0] = moment(d).format("DD/MM/YYYY hh:mm:ss");
      }
      return row;
    });

    /** @type {object[]} */
    this.imagesMetadata = images_metadata;

    /** @type {object[]} */
    this.metadata = metadata;
  }

  /**
   * Map data from api to instance of DataSourceMonitorData
   * @returns {DataSourceMonitorData} new instance with the mapped data
   */
  static fromApi({ header, data, images_metadata, metadata }) {
    return new DataSourceMonitorData(header, data, images_metadata, metadata);
  }

  /**
   * @returns a copy of the header
   */
  getHeader() {
    return [...this.header].slice(0, this.getHeadersLength());
  }

  /**
   * @returns a copy of the rows
   */
  getRows() {
    return [...this.rows];
  }

  /**
   * @param {any[]} rows
   */
  appendRows(rows) {
    this.rows.push(...rows);
  }

  /**
   * @returns a copy of the imagesMetadata
   */
  getImagesMetadata() {
    return [...this.imagesMetadata];
  }

  /**
   * @returns a copy of the imagesMetadata
   */
  getImagesMetadataForTable() {
    return this.getImagesMetadata();
  }

  /**
   * @returns the cloned instance
   */
  clone() {
    return new DataSourceMonitorData(this.getHeader(), this.getRows(), this.getImagesMetadata());
  }

  /**
   * @param {Array} data
   * @returns {DataSourceMonitorData}
   */
  static fromClassificationAPI(data) {
    const headers = ["Date", "Container", "Plate name", "INS time", "status"];
    const rows = data.map((item) => {
      const d = item.created_at;
      return [d, item.info.container_id, item.info.plate_id, item.processing_time, item.finished];
    });

    const metadata = data.map((item) => {
      return {
        monitor_data_id: item.id,
        taskType: TaskTypes.CLASSIFICATION,
        requireManualInspection: item.require_manual_inspection,
      };
    });

    return new DataSourceMonitorData(headers, rows, [], metadata);
  }

  convertUTCDate(date) {
    return new Date(date);
  }

  getHeadersLength() {
    return this.getRows()?.[0]?.length;
  }

  resetPlateStatus(index, newRow) {
    const updatedRows = this.getRows();
    updatedRows[index] = newRow;
    const monitorData = new DataSourceMonitorData(this.header, updatedRows, this.imagesMetadata, this.metadata);
    return monitorData;
  }
}
